import { Popover, Icon } from "antd";
import React, { useState, useMemo, useEffect } from "react";
import moment from "moment";
import AxiosTS from "../../core/axios";
import { getParameterByName } from "../../core/function";
import "./ServiceWXModal.less";
import newXmTD from "../../core/newXmTD";

const playday = [6, 0];

function ServiceWXModal(props) {
  const [hadClicked, setHadClicked] = useState(false);
  const [url, setUrl] = useState("");
  const [visible, setVisible] = useState(false);
  const [workTime, setWorkTime] = useState(true);
  useEffect(() => {
    let _workTime = true;
    const start_time = moment().startOf("day").valueOf() + 60 * 570 * 1000; //早上9点半
    const end_time = moment().endOf("day").valueOf() - 60 * 329 * 1000;
    const current = moment().valueOf();
    if (playday.includes(moment().day())) _workTime = false;
    if (current < start_time || current > end_time) _workTime = false;
    setWorkTime(_workTime);
  });

  useEffect(() => {
    const LSInstId = localStorage.getItem("instId");
    const ParamInstId = getParameterByName("instId") || '';
    const instId = ParamInstId || LSInstId;
    const LSChildAccount = localStorage.getItem("isChildAccount");
    const ParamChildAccount = getParameterByName("isChildAccount") || '';
    const isChildAccount = ParamChildAccount || LSChildAccount;
    isChildAccount &&
      localStorage.setItem("isChildAccount", isChildAccount);
    instId && localStorage.setItem("instId", instId);
    function getoperatorWechat() {
      if (instId) {
        AxiosTS.postJSON("manage/anon/helpCenter/operatorWechat", {
          instId,
        }).then(({ result }) => {
          setUrl(result);
        });
      }
    }
    instId && getoperatorWechat();
  }, []);

  /**
   * type1: M端已关联企业微信，且在工作时段内
   * type2: M端未关联企业微信
   * type3: M端已关联企业微信，但不在工作时段内
   */
  const writing = useMemo(() => {
    let type = "type1";
    let pattern = {
      type1: {
        tips: (
          <span>
            如您遇到一些复杂问题最终仍未得到解决，可添加您校区的运营顾问联系进行沟通处理。
          </span>
        ),
        img: <img src={url} alt='微信名片' />,
        text: <span>微信扫一扫添加</span>,
      },
      type2: {
        tips: (
          <span>
            如您遇到一些复杂问题最终仍未得到解决，可联系专属运营顾问反馈和处理。
          </span>
        ),
        img: (
          <img
            src='https://image.xiaomaiketang.com/xm/KNMZMxtdhs.png'
            alt='微信名片'
          />
        ),
        text: (
          <span>
            名片暂未提供，请
            <span
              className='stress'
              style={{ cursor: "pointer" }}
              onClick={() => {
                const btn = document.getElementById("btn");
                btn.click();
                setVisible(false);
              }}
            >
              联系人工客服
            </span>
          </span>
        ),
      },
      type3: {
        tips: (
          <span>
            如您遇到一些复杂问题最终仍未得到解决，可联系专属运营顾问反馈和处理。
          </span>
        ),
        img: <img className='mask-img' src={url} alt='微信名片' />,
        text: (
          <span>
            工作时间（周一至周五，9:30 ~ 18:30）
            <div style={{ textAlign: "center" }}>
              请
              <span
                className='stress'
                style={{ cursor: "pointer" }}
                onClick={() => {
                  const btn = document.getElementById("btn");
                  btn.click();
                  setVisible(false);
                }}
              >
                联系人工客服
              </span>
            </div>
          </span>
        ),
      },
    };
    if (workTime && url) type = "type1";
    if (!workTime && url) type = "type3";
    if (!url) type = "type2";
    return pattern[type];
  }, [url, workTime]);

  const content = (
    <div className='wx-card'>
      <div className='tips'>{writing.tips}</div>
      <div className='title'>
        <img src='https://image.xiaomaiketang.com/xm/ePbDy6HwDw.png' alt='' />
        <span>运营顾问名片</span>
      </div>
      <div className='card-display'>{writing.img}</div>
      <div className='text'>{writing.text}</div>
    </div>
  );
  const isChildAccount =
    localStorage.getItem("isChildAccount") ||
    getParameterByName("isChildAccount");
  return isChildAccount === "false" ? (
    <Popover
      trigger='click'
      visible={visible}
      placement='bottomLeft'
      content={content}
      onVisibleChange={() => {
        setVisible((old) => !old);
      }}
      onClick={() => {
        let paramList =
          JSON.parse(localStorage.getItem("ParamsFromB") || "") || {};
        const LSInstId = localStorage.getItem("instId");
        const ParamInstId = getParameterByName("instId");
        const instId = ParamInstId || LSInstId;
        paramList.name = "B端-点击-联系运营顾问";
        paramList.docId = "";
        paramList.instId = instId;
        if (!visible)
          newXmTD("click_HelpCenter_Contact", "点击联系运营顾问", paramList);
        setHadClicked((old) => !old);
      }}
    >
      <span className='label' style={{ cursor: "pointer" }}>
        联系运营顾问
        <Icon
          style={{ fontSize: 12, marginLeft: 5 }}
          type={!hadClicked ? "down" : "up"}
        />{" "}
      </span>
    </Popover>
  ) : null;
}

export default ServiceWXModal;
